import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import MobileContext from 'context/MobileContext';
import { closeIcon } from 'assets/icons';
import styles from './styles.module.css';

export const Modal = ({
  children,
  isOpened,
  setIsOpened,
  wrapperStyles,
  inputClassName,
  showCloseIcon,
}) => {
  const isMobile = useContext(MobileContext);
  useEffect(() => {
    if (isOpened) {
      document.body.style.overflowY = 'hidden';
      document.body.style.height = '100%';
    } else {
      document.body.style.position = 'static';
      document.body.style.overflowY = 'auto';
    }
  }, [isOpened]);
  return (
    <div className={styles.container}>
      {isOpened && <div onClick={() => setIsOpened(false)} className={styles.shadow} />}
      <div
        className={`${styles.modalContainer} ${
          isOpened ? styles.openedModalContainer : null
        } ${isMobile ? styles.containerMobile : null} ${inputClassName}`}
        style={wrapperStyles}
      >
        {showCloseIcon && (
          <div onClick={() => setIsOpened(false)}>
            <img src={closeIcon} alt="close" className={styles.closeIcon} />
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.element.isRequired,
  isOpened: PropTypes.bool.isRequired,
  setIsOpened: PropTypes.func.isRequired,
  wrapperStyles: PropTypes.object,
  inputClassName: PropTypes.string,
  showCloseIcon: PropTypes.bool,
};
Modal.defaultProps = {
  wrapperStyles: {},
  inputClassName: '',
  showCloseIcon: false,
};
